export const ECOMMERCE_PLATFORMS = [
  {
    label: '',
    value: '',
  },
  {
    label: 'Magento',
    value: 'magento',
  },
  {
    label: 'Shopify',
    value: 'shopify',
  },
  {
    label: 'Commerce Cloud',
    value: 'commerce_cloud',
  },
  {
    label: 'Websphere',
    value: 'websphere',
  },
  {
    label: 'ATG',
    value: 'atg',
  },
  {
    label: 'Big Commerce',
    value: 'big_commerce',
  },
  {
    label: 'Prestashop',
    value: 'prestashop',
  },
  {
    label: 'Hybris',
    value: 'hybris',
  },
  {
    label: 'Open Cart',
    value: 'open_cart',
  },
  {
    label: 'Volusion',
    value: 'volusion',
  },
  {
    label: 'Woo Commerce',
    value: 'woo_commerce',
  },
  {
    label: '3d Cart',
    value: '3d_cart',
  },
  {
    label: 'Legacy',
    value: 'legacy',
  },
  {
    label: "I'm not sure",
    value: 'notsure',
  },
];
